import React from 'react';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';

const DeleteDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Are you sure you want to delete?',
  compact = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={compact ? 'xs' : 'sm'}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      PaperProps={{
        elevation: 3,
        sx: { borderRadius: compact ? 1.5 : 2, border: '1px solid var(--color-border)' },
      }}
    >
      <DialogTitle
        id="delete-dialog-title"
        sx={{
          py: compact ? 1.25 : 1.5,
          px: compact ? 2 : 2.2,
          fontSize: compact ? '0.95rem' : '1rem',
          fontWeight: 700,
          color: 'var(--color-heading)',
        }}
      >
        {title}
      </DialogTitle>

      <DialogActions sx={compact ? { px: 2, py: 1, gap: 1 } : { p: 2 }}>
        <Button
          onClick={onConfirm}
          size={compact ? 'small' : 'medium'}
          sx={{
            borderRadius: compact ? '0.5rem' : '2rem',
            backgroundImage: 'var(--gradient-primary)',
            color: 'white',
            textTransform: 'none',
            minWidth: compact ? 72 : undefined,
          }}
        >
          Yes
        </Button>
        <Button
          onClick={onClose}
          size={compact ? 'small' : 'medium'}
          variant="outlined"
          sx={{
            borderRadius: compact ? '0.5rem' : '2rem',
            borderColor: 'var(--color-border-soft)',
            color: 'var(--color-heading)',
            textTransform: 'none',
            minWidth: compact ? 72 : undefined,
          }}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
